import React, { useState,useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast,ToastContainer } from 'react-toastify';
import { updateCustomer,getCustomer } from '../../redux/actions/customer/CustomerAction';

const editCustomer = ({customer,getCustomer,updateCustomer,history}) => {

    const [firstName,setFirstName]=useState(customer.firstName);
    const [lastName,setLastName]=useState(customer.lastName);
    const [email,setEmail]=useState(customer.email);
    const[address,setAddress]=useState(customer.address);

    const params=useParams();
    useEffect(()=>{
        getCustomer(params.customerId);
        // console.log(params.customer);
    },[]);
    
    const handleUpdate=(e)=>{

        e.preventDefault();

        if (!firstName || !lastName || !email || !address) {
            return alert('Please fill in all fields!!');
        }
        updateCustomer(params.customerId,{
            firstName,
            lastName,
            email,
            address
        });
        
        history.push(`/customer/${params.customerId}/cart`);
        
    };

    const handleBack=()=>{
        history.push(`/customer/${params.customerId}/cart`);
    };

    const handleClear=(e)=>{
        e.preventDefault();
        toast.error('All fields are Cleared');
        setFirstName('');
        setLastName('');
        setEmail('');
        setAddress('');

    };



    return (
        <div className="container-fluid">
            <h4 className="text-center text-dark py-2 ">Edit Customer Details</h4>
            <div className="row">
                <div className="col-md-5 p-5 mx-auto shadow d-flex justify-content-center">
                    <form className='create-form'>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="First name"
                                value={firstName}
                                onChange={(e)=>setFirstName(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Last name"
                                value={lastName}
                                onChange={(e)=>setLastName(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e)=>setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Address"
                                value={address}
                                onChange={(e)=>setAddress(e.target.value)}
                                required
                            />
                        </div>
                        
                         
                        <div className="form-group my-3">
                            <button onClick={handleUpdate} type="submit" className=" btn btn-primary" >
                Submit
                            </button>
                            <button  onClick={handleClear} className="btn btn-warning mx-2">
                Clear
                            </button>
                            <button onClick={()=>handleBack()} className="btn btn-danger mx-2">
                Cancel
                            </button> 
                        </div>
                    </form>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

const mapStateToProps = (state) => {
    console.log(state.customers);
    return{customer: state.customers};

};
const mapDispatchToProps={updateCustomer,getCustomer};

export default connect(mapStateToProps, mapDispatchToProps)(editCustomer);
